import { PutBuildingReplaceReq } from '@gateway.Building'
import { yamadumiApi } from '../yamadumi-api'

export class BuildingReplaceGateway {
  static putBuildingReplace = async (params: PutBuildingReplaceReq) => {
    return await yamadumiApi.put('/api/building/replace', params)
  }
}
